import { Result, Space, Spin } from "antd";
import { useLazyCheckAnswerQuery, useUpdateUserStatusMutation } from "api";
import Banner from "assets/images/Header-GFVoice.png";
import { DataAnswer, DataPreAnswer } from "models";
import { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import styled from "styled-components";
import { decrypt } from "utils";
import { FormSurvey, WarningModal } from "./components";
import { FromSubmitSurvey } from "./components/FromSubmitSurvey";

const WpQuestion = styled.div`
	width: 750px;
	margin: auto;
	@media (max-width: 750px) {
		width: 100%;
	}
`;

export const BoxImg = styled.div`
	width: 100%;
	overflow: hidden;
	border-radius: 10px;
	img {
		width: 100%;
	}
`;

export const Question = () => {
	const [searchParams] = useSearchParams();
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [answers, setAnswers] = useState<DataAnswer[]>([]);
	const [checkAnswer, { data: dataCheckAnswer, isLoading }] = useLazyCheckAnswerQuery();
	const [updateUserStatus] = useUpdateUserStatusMutation();
	const [preAnswers, setPreAnswers] = useState<DataPreAnswer[]>([]);

	const [resultCreateAnswer, setResultCreateAnswer] = useState<string>("");

	const key = searchParams.get("key");

	useEffect(() => {
		if (!key) return;

		checkAnswer({ key });
		updateUserStatus({ key });
	}, [key, checkAnswer, updateUserStatus]);

	const user = useMemo(() => {
		if (!key) return null;
		try {
			const user = decrypt(key);
			return user;
		} catch (error) {}

		return null;
	}, [key]);

	const showModal = ({ dataAnswers, dataPreAnswers }: { dataAnswers: DataAnswer[]; dataPreAnswers: DataPreAnswer[] }) => {
		setIsModalOpen(true);
		setAnswers(dataAnswers);
		setPreAnswers(dataPreAnswers);
	};

	const handleCancel = (ele: boolean) => {
		setIsModalOpen(false);

		if (ele) {
			checkAnswer({ key });
		}
	};

	return <Result status="404" title="Hiện tại khảo sát đã đóng" />;

	// if (!user) return <Result status="403" title="Bạn không có quyền truy cập" subTitle="Sorry, you are not authorized to access this page." />;

	// return (
	// 	<WpQuestion>
	// 		<Space style={{ display: "flex", justifyContent: "end", marginBottom: 10 }}>{/* <SwitchLanguage setLang={setLang} /> */}</Space>
	// 		<Space direction="vertical" style={{ marginBottom: 100, width: "100%" }}>
	// 			<BoxImg>
	// 				<img src={Banner} alt="" />
	// 			</BoxImg>

	// 			{isLoading ? (
	// 				<Space direction="vertical" style={{ width: "100%", textAlign: "center" }}>
	// 					<Spin />
	// 				</Space>
	// 			) : (
	// 				<>
	// 					{/* {!dataCheckAnswer ? <FormSurvey showModal={showModal} user={user} /> : <FromSubmitSurvey user={user} dataAnswers={[]} />} */}
	// 					{!resultCreateAnswer ? <FormSurvey showModal={showModal} user={user} /> : <FromSubmitSurvey user={user} dataAnswers={[]} />}
	// 					<WarningModal
	// 						handleCancel={handleCancel}
	// 						preAnswers={preAnswers}
	// 						answers={answers}
	// 						isModalOpen={isModalOpen}
	// 						handleSetResultCreateAnswer={(value) => {
	// 							setResultCreateAnswer(value);
	// 						}}
	// 					/>
	// 				</>
	// 			)}
	// 		</Space>
	// 	</WpQuestion>
	// );
};
